
import { getField, updateField } from 'vuex-map-fields';
import { me, update as updateUser, updateFamilyMembers} from '@/service/UsersService'
export default {
    namespaced: true,
    state: {
            id: "",
            name: "",
            surname: "",
            email: "",
            address_country: "",
            family_members: [],
            achieved: [],
            name_backup: "",
            surname_backup: "",
            ingredients_allergies: [],
            not_liked_ingredients: [],
            preferred_cooking_meal: "",
            preferred_course: "",
            sweet_or_savoury: "",
            avatar: null,
            appliances: [],
            shopping_list:[]
    },
    mutations: {
        updateField,
        dump(state) {
            console.log(state);
        },
        updateId(state, id) {
            state.id = id;
        },
        updateName(state, name) {
            state.name = name;
        },
        updateSurname(state, surname) {
            state.surname = surname;
        },
        updateEmail(state, email) {
            state.email = email;
        },
        updateAddressCountry(state, address_country) {
            state.address_country = address_country;
        },
        updateFamilyMembers(state, family_members) {
            state.family_members = family_members;
        },
        updateAchieved(state, achieved) {
            state.achieved = achieved;
        },
        updatePreferredCookingMeal(state, preferred_cooking_meal) {
            state.preferred_cooking_meal = preferred_cooking_meal;
        },
        updatePreferredCourse(state, preferred_course) {
            state.preferred_course = preferred_course;
        },
        updateSweetOrSavoury(state, sweet_or_savoury) {
            state.sweet_or_savoury = sweet_or_savoury;
        },
        updateIngredientsAllergies(state, ingredients_allergies) {
            state.ingredients_allergies = ingredients_allergies;
        },
        updateNotLikedIngredients(state, not_liked_ingredients) {
            state.not_liked_ingredients = not_liked_ingredients;
        },
        addFamilyMember(state, family_member) {
            state.family_members = [...state.family_members, family_member];
           
        },
        updateNameBackup(state, name) {
            state.name_backup = name;
        }
        ,
        updateSurnameBackup(state, surname) {
            state.surname_backup = surname;
        },
        updateAvatar(state, avatar) {
            state.avatar = avatar;
        },
        updateAppliances(state, appliances) {
            state.appliances = appliances;
        },
        updateShoppingList(state, shopping_list) {
            state.shopping_list = shopping_list;
        }
    },
    actions: {
        loadMe: async ({commit, rootGetters}) => {
            let accesstoken = rootGetters["userdata/getAccessToken"];
            me(accesstoken).then((me) => {
                let { id, name, surname, email, address_country } = me;
                commit("updateId", id );
                commit("updateName", name );
                commit("updateSurname", surname );
                commit("updateEmail", email );
                commit("updateAddressCountry", address_country );
                commit("updateFamilyMembers", me.family_members );
                commit("updateNameBackup", name );
                commit("updateSurnameBackup", surname );
                commit("updateAchieved", me.achieved );
                commit("updateIngredientsAllergies", me.ingredients_allergies );
                commit("updateNotLikedIngredients", me.not_liked_ingredients );
                commit("updatePreferredCookingMeal", me.preferred_cooking_meal );
                commit("updatePreferredCourse", me.preferred_course );
                commit("updateSweetOrSavoury", me.sweet_or_savoury );
               commit("updateShoppingList", me.shopping_list );
                if (!me.avatar || !me.avatar.url) {
                    commit("updateAvatar", { url: '/assets/img/default-avatar.webp' });
                } else {
                    commit("updateAvatar", me.avatar );
                }
                
                commit("updateAppliances", me.appliances );
            });
        },
        addFamilyMember: async ({state, commit, rootGetters}, family_member) => {
            
            commit("addFamilyMember", family_member);
            let accesstoken = rootGetters["userdata/getAccessToken"];
            return updateFamilyMembers(accesstoken, state.id, [family_member]);
        },
        update: async ({state, rootGetters}) => {
            let accesstoken = rootGetters["userdata/getAccessToken"];
            return updateUser(accesstoken, state.id, state.name, state.surname, state.email, state.address_country);
        }
      
    },
    getters: {
        // Add the `getField` getter to the
        // `getters` of your Vuex store instance.
        getField,
        id: state => state.id,
        name: state => state.name,
        surname: state => state.surname,
        email: state => state.email,
        address_country: state => state.address_country,
        family_members: state => state.family_members,
        name_backup: state => state.name_backup,
        surname_backup: state => state.surname_backup,
        achieved: state => state.achieved,
        ingredients_allergies: state => state.ingredients_allergies,
        not_liked_ingredients: state => state.not_liked_ingredients,
        preferred_cooking_meal: state => state.preferred_cooking_meal,
        preferred_course: state => state.preferred_course,
        sweet_or_savoury: state => state.sweet_or_savoury,
        avatar: state => state.avatar,
        appliances: state => state.appliances,
        shopping_list: state => state.shopping_list,
        achievement_points: state => {
            let points = 0;
            state.achieved.forEach(achieved => {
                points += achieved.achievement.points;
            });
            return points;
        }
      },

}